<div class="card rounded-3 shadow border-gray">
  <div class="card-title fs-5 fw-bold px-3 dark-blue-text mt-3">{{ label() }}</div>

  <div class="card-body d-flex flex-column">
    @for (markertType of markerTypes(); track markertType.id) {
      <div class="cursor-pointer" (click)="goToSearch(markertType)">
        <div
          class="profile-place rounded-4 d-flex align-items-center"
          [class.mb-3]="!$last"
          [ngStyle]="changeStyle($index)"
          (mouseover)="setHoverToMarkerType($event, $index)"
          (mouseout)="setHoverToMarkerType($event, $index)"
        >
          <img [lazyLoad]="markertType.icon | cdnUrl: 100 : true" class="profile-place-icon" />
          <span class="profile-place-name">{{ markertType.language.name }}</span>

          <i class="inm-icon-arrow-forward ms-auto me-3"></i>
        </div>
      </div>
    }
  </div>
</div>
